export default "__VITE_ASSET__CiOqqFfh__"